import './checkbox.css';
const CheckBox = ({isChecked, onChange}) => {
    return (<label className="container">
    <input type="checkbox" defaultChecked={isChecked}/>
    <span className="checkmark" onClick={onChange}></span>
  </label>)
}

export default CheckBox;